import { BonusCardType } from "@omni/types/enums/bonusCardType.enum";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { NumericTextField } from "@/components/Form/RHF/FormFields/NumericTextField/NumericTextfield.component";
import { RadioFieldArray } from "@/components/Form/RHF/FormFields/RadioFieldArray/radioFieldArray.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as BonusCardUtils from "@/utils/bonusCard";

import { CheckoutCustomerFormValues } from "../checkoutCustomer.schema";

const CheckoutBonusCardAvailableFormBlock = () => {
    const { t } = useGranite();
    const { getValues, subscribe, setValue } =
        useFormContext<CheckoutCustomerFormValues>();
    const [showInput, setShowInput] = useState(
        getValues("bonusCardAvailable") === Boolean(true).toString()
    );
    const [isEBonusCardNumber, setIsEBonusCardNumber] = useState(
        BonusCardUtils.isType(
            BonusCardType.Electronic,
            getValues("bonusCard.number")
        )
    );

    useEffect(() => {
        const callback = subscribe({
            formState: { values: true },
            callback: ({ values }) => {
                if (
                    values.bonusCardAvailable === Boolean(false).toString() &&
                    !isEBonusCardNumber &&
                    values.bonusCard?.number
                ) {
                    setValue("bonusCard.number", "");
                }

                const shouldShowInput =
                    values.bonusCardAvailable === Boolean(true).toString();
                if (shouldShowInput !== showInput) {
                    setShowInput(shouldShowInput);
                }

                const isEBonusCard = BonusCardUtils.isType(
                    BonusCardType.Electronic,
                    values.bonusCard?.number
                );
                if (isEBonusCard !== isEBonusCardNumber) {
                    setIsEBonusCardNumber(isEBonusCard);
                }
            }
        });
        return () => callback();
    }, [subscribe, setValue, isEBonusCardNumber, showInput]);

    if (isEBonusCardNumber) {
        return <div>{getValues("bonusCard.number")}</div>;
    }

    return (
        <>
            <div className={cn("tw:mb-4")}>
                <RadioFieldArray<CheckoutCustomerFormValues, string>
                    label={t(
                        "checkout.customerDetails.bonusCardAvailable.label"
                    )}
                    name="bonusCardAvailable"
                    required
                    options={[
                        {
                            label: t("general.form.choice.yes"),
                            value: Boolean(true).toString()
                        },
                        {
                            label: t("general.form.choice.no"),
                            value: Boolean(false).toString()
                        }
                    ]}
                />
            </div>
            {showInput && (
                <Row>
                    <Col md={6}>
                        <NumericTextField<CheckoutCustomerFormValues>
                            name="bonusCard.number"
                            label={t("general.form.bonusCard.label")}
                            placeholder={t(
                                "general.form.bonusCard.placeholder"
                            )}
                            required={true}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export { CheckoutBonusCardAvailableFormBlock };
